import React from 'react';
import { styled } from '@linaria/react';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { Icon } from '@livecommerce/design-system';

const DragDiv = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor || 'black'};
  border-radius: 4px 4px 0 0;
  cursor: move;
  z-index: 9999;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right};
`;

const HANDLE_HEIGHT = 16; // The height of our drag handle
const HANDLE_EXTRA_HEIGHT = 8; // Extra space that overlaps the element behind it to cover the otherwise rounded borders of the element

const DragHandle = ({ onMouseDown, position, iframeRect }) => {
  const { t } = useLocalization();
  if (!iframeRect || iframeRect.height === 0) {
    return null;
  }

  return (
    <DragDiv
      onMouseDown={onMouseDown}
      data-testid="salesforce-chat-drag-handle"
      title={t('general.dragToMove')}
      bottom={`${position.bottom + iframeRect.height - HANDLE_EXTRA_HEIGHT}px`}
      right={`${position.right}px`}
      width={`${iframeRect.width}px`}
      height={`${HANDLE_HEIGHT + HANDLE_EXTRA_HEIGHT}px`}
    >
      <Icon name="more" color="white" width={24} height={24} />
    </DragDiv>
  );
};

export default DragHandle;

